import React from 'react';
import { IconButton, InputAdornment, TextField, type TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordTextField: React.FC<TextFieldProps> = ({ slotProps, onBlur, margin, size, ...rest }) => {
  const [visible, setVisible] = React.useState(false);
  const inputSlot = typeof slotProps?.input === 'object' ? slotProps.input : undefined;

  return (
    <TextField
      {...rest}
      margin={margin}
      // In v4, margin="dense" also made the input itself dense (40px); v9 only sets the margins. The screens
      // using this still pass v4's props, so dense keeps meaning what it did.
      size={size ?? (margin === 'dense' ? 'small' : undefined)}
      type={visible ? 'text' : 'password'}
      onBlur={(e) => {
        setVisible(false);
        onBlur?.(e);
      }}
      slotProps={{
        ...slotProps,
        input: {
          ...inputSlot,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                tabIndex={-1}
                size="small"
                aria-label={visible ? 'Hide password' : 'Show password'}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setVisible((prev) => !prev)}
              >
                {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default PasswordTextField;
